<template>
    <div>
       <canvas :id="id"></canvas>
    </div>
</template>


<script>
    import axios from "axios";
    import chart from "chart.js";

    export default {
        name: 'gru-chart',
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default: 'canvas'
            },
            name: {
                type: String,
                default: 'canvas'
            },
            type: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            query: {
                type: String,
                default: ''
            },
            label: {
                type: Array,
                default: []
            },
            labelField: {
                type: String,
                default: null
            },
            indexField: {
                type: String,
                default: null
            }

        },
        watch: {
            query: function (data) {
                this.getData();
            },
            label:function(data){
                this.chartLabel =[];
                this.chartColor =[];
                for(let i=0;i<data.length;i++){
                    this.chartLabel.push(data[i].label);
                    this.chartColor.push(data[i].color);
                }
            }
        },

        created() {
            this.getData();
        },

        data: () => {
            return {
                text: null,
                error: false,
                chartData:[],
                chartLabel:[],
                chartColor:[],
                errorMessage: []
            }
        },

        methods: {
            getData(){
                axios.post(process.env.VUE_APP_API_URL + "/chart/query?query=" + this.query).then(
                    data=>{
                        this.initChart();
                        this.chartData =[];
                        this.chartLabel =[];

                        for(let i=0;i<data.length;i++){
                            let rs = data[i];
                            //console.log(rs);
                            this.chartLabel.push(rs[this.labelField])
                            this.chartData.push(rs[this.indexField]);
                        }
                        this.createChart();
                    }
                );

            },

            initChart(){
                this.chartLabel =[];
                this.chartColor =[];
                for(let i=0;i<this.label.length;i++){
                    this.chartLabel.push(this.label[i].label);
                    this.chartColor.push(this.label[i].color);
                }
            },

            createChart() {
                const ctxmark = document.getElementById(this.id);
                //console.log(this.chartLabel);
                //console.log(this.chartColor);
                //console.log(this.chartData);
                const chartmark = new chart(ctxmark, {
                    type: this.type,
                    data: {
                        labels: this.chartLabel,
                        datasets: [
                            {
                                data: this.chartData,
                                backgroundColor: this.chartColor,
                            }
                        ]
                    },
                    options: {
                        title: {
                            display: true,
                            text: this.title
                        },
                        plugins: {
                            legend: {
                                display: false,
                            }
                        }

                    },
                });
            }
        }
    }
</script>
